export default __webpack_public_path__ + "0a219ebb84a037c8c9dd5ae2eaefa71d.gif";